export default __webpack_public_path__ + "static/media/PC.7874b0cd.png";